import { getAuthRole } from 'shared/auth/AuthToken';
import { trackEvent } from 'shared/helpers/Analytics';
import { useCarrierInfo } from 'shared/modules/carrier-profile/data/CarrierInfoAPI';

type SuperPayAnalyticsProps =
  | {
      name:
        | 'Carrier Opened SuperPay Promo Page'
        | 'Carrier Submitted Bank Account'
        | 'Carrier Submitted Business Details'
        | 'Carrier Opened SuperPay Settings Page'
        | 'Carrier Started Bank Account Verification'
        | 'Carrier Clicked I Cant Find MV Code';
    }
  | {
      name: 'Carrier Clicked Set Up SuperPay';
      utm_content: 'Top Button' | 'Footer Button';
    }
  | {
      name: 'Carrier Submitted Bank Account Verification';
      verification_response: string | undefined;
    }
  | {
      name: 'Carrier Submitted Transaction Screenshot';
      outcome: 'verified' | 'submitted_for_review';
      auto_verification:
        | 'verified'
        | 'rejected_incorrect'
        | 'rejected_exceeded'
        | 'error'
        | 'not_attempted';
      ocr_result:
        | 'found'
        | 'not_found'
        | 'multiple_codes'
        | 'pdf'
        | 'timeout'
        | 'error'
        | 'off';
      ocr_duration_ms: number | undefined;
      total_duration_ms: number;
    }
  | {
      name: 'Carrier Closed Screenshot Check Dialog';
      choice: 'keep_waiting' | 'close' | 'dismissed';
    };

export function trackSuperPayEvent(event: SuperPayAnalyticsProps) {
  const { name, ...props } = event;
  trackEvent(name, { ...props });
}

export function useBankAccountVerificationAnalytics() {
  const { data: carrierInfo } = useCarrierInfo();
  const carrierProps = {
    carrier_name: carrierInfo?.name ?? null,
    user_role: getAuthRole(),
  };

  return {
    trackVerified: () =>
      trackEvent('Carrier Submitted Bank Account Verification', {
        ...carrierProps,
        verification_response: 'verified',
      }),
    trackCantFindMvCode: () =>
      trackEvent('Carrier Clicked I Cant Find MV Code', carrierProps),
  };
}
